import React from 'react';
import { FiSend } from 'react-icons/fi';

import Message from '@/components/TaskCard/Message';
import type { ChatMessage } from '@/components/Widget';

import styles from './CommentsSection.module.scss';

interface CommentsSectionProps {
  displayMessages: ChatMessage[];
  isHidden: boolean;
  messageInput: string;
  hasComments: boolean;
  displayCount: number;
  onToggleComments: () => void;
  onMessageInputChange: (value: string) => void;
  onSendMessage: () => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  isSending?: boolean;
  scrollable?: boolean;
  onRefetchMessages?: () => void;
}

export const CommentsSection: React.FC<CommentsSectionProps> = ({
  displayMessages,
  isHidden,
  messageInput,
  hasComments,
  displayCount,
  onToggleComments,
  onMessageInputChange,
  onSendMessage,
  onKeyDown,
  isSending = false,
  scrollable = false,
  onRefetchMessages,
}) => {
  return (
    <div className={styles.container}>
      {hasComments && (
        <div className={styles.commentsSection}>
          <div className={styles.commentsHeader}>
            <p className={styles.commentsTitle}>Comments ({displayCount})</p>
            <button
              className={styles.hideButton}
              onClick={(e) => {
                e.stopPropagation();
                onToggleComments();
              }}
            >
              {isHidden ? 'Show' : 'Hide'}
            </button>
          </div>
          {!isHidden && (
            <div
              style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}
              className={scrollable ? styles.messagesList : undefined}
            >
              {displayMessages.map((message) => (
                <Message
                  key={message.id}
                  sender={message.sender}
                  role=""
                  message={message.message}
                  unread={false}
                  createdAt={message.createdAt}
                  updatedAt={message.updatedAt}
                  creatorId={message.creatorId}
                  messageId={message.id}
                  roomId={message.roomId}
                  onDeleteSuccess={onRefetchMessages}
                />
              ))}
            </div>
          )}
        </div>
      )}

      <div className={`${styles.messageInputContainer}`} onClick={(e) => e.stopPropagation()}>
        <input
          type="text"
          className={styles.messageInput}
          placeholder="The new impeller arrives Tuesday."
          value={messageInput}
          onChange={(e) => onMessageInputChange(e.target.value)}
          onKeyDown={onKeyDown}
          disabled={isSending}
        />
        <button className={styles.sendButton} onClick={onSendMessage} disabled={isSending}>
          <FiSend />
        </button>
      </div>
    </div>
  );
};
